import * as React from 'react'

import { Modal, Button, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'

export interface WithConfirmProps {
  confirm: (onConfirm: () => void, options: ConfirmOptions) => void
}

export interface ConfirmOptions {
  title?: string
  description?: any
  confirmationText?: string
  cancellationText?: string

  onClose?: () => {}
  onCancel?: () => {}
}

type OnConfirm = () => void

const defaultOptions: ConfirmOptions = {
	description: '',
	title: 'Please confirm',
	confirmationText: 'Yes',
	cancellationText: 'Cancel'
}

const withConfirm = WrappedComponent => props => {
	const [onConfirm, setOnConfirm] = React.useState<OnConfirm | undefined>(undefined)
	const [options, setOptions] = React.useState(defaultOptions)
	const {
		title,
		onClose,
		onCancel,
		description,
		cancellationText,
		confirmationText
	} = options

	const handleClose = React.useCallback(() => {
    if (onClose) {
      onClose()
    }

		setOnConfirm(undefined)
  }, [onClose])
  
	const handleCancel = React.useCallback(() => {
    if (onCancel) {
      onCancel()
    }

		handleClose()
  }, [onCancel, handleClose])
  
	const handleConfirm = React.useCallback(
		(...args) => {
      if (onConfirm) {
        onConfirm()
      }

			handleClose()
		},
		[onConfirm, handleClose]
	)

	/* Returns function opening the dialog, passed to the wrapped component. */
	const confirm = React.useCallback(
		(methodToInvoke, customOptions = {}) => {
			setOnConfirm(() => methodToInvoke)
			setOptions({ ...defaultOptions, ...customOptions })
		},
		[]
	)

	return (
		<React.Fragment>
			<WrappedComponent {...props} confirm={confirm} />
			<Modal isOpen={!!onConfirm}>
        <ModalHeader toggle={handleCancel}>{title}</ModalHeader>
        <ModalBody>
          {description}
        </ModalBody>
        <ModalFooter>
          <Button color="light" className="ggbutton" onClick={handleCancel}>{cancellationText}</Button>
          <Button color="primary" className="ggbutton" onClick={handleConfirm}>
            {confirmationText}
          </Button>
        </ModalFooter>
      </Modal>
		</React.Fragment>
	)
}

export default withConfirm



// WEBPACK FOOTER //
// ./src/lib/helpers/withConfirm.tsx